import { IAM } from '../apis.js';
import { isErrorResponse } from './utils.js';
const req = IAM('/auth', false);
export const login = (email, password) => req('POST', `/login`, {
    body: {
        username: email,
        password,
    },
}).then((x) => {
    if (isErrorResponse(x)) {
        if (x.message === 'Password reset needed') {
            throw new Error('Dit password skal nulstilles');
        }
        throw Error('Forkert email eller password');
    }
    return x;
});
export const verifyTwoFactor = (username, password, token) => req('POST', '/two-factor', { body: { username, password, token } }).then((res) => {
    if (isErrorResponse(res)) {
        throw new Error(res.message);
    }
    return res;
});
export const initiatePasswordReset = (username) => req('POST', '/reset-password', {
    body: {
        username,
    },
}).then((res) => {
    if (isErrorResponse(res)) {
        throw Error(res.message);
    }
    return res;
});
export const updatePassword = (username, token, password) => req('POST', '/update-password', {
    body: {
        username,
        token,
        password,
    },
}).then((res) => {
    if (isErrorResponse(res)) {
        throw Error(res.message);
    }
    return res;
});
export const createPassword = (token, password) => req('POST', '/create-password', {
    body: {
        token,
        password,
    },
}).then((res) => {
    if (isErrorResponse(res)) {
        throw Error(res.message);
    }
    return res;
});
//# sourceMappingURL=auth.js.map